import React, { useState } from "react";
import { useSite } from "../context/site";
import { TrajectoryBand, BelieveBlock } from "../components/site/kit";
import { Splash } from "./home/Splash";
import { Hero } from "./home/Hero";
import { WhatWeDo } from "./home/WhatWeDo";
import { SwitchModel } from "./home/SwitchModel";
import { Capabilities } from "./home/Capabilities";
import { Situations } from "./home/Situations";
import { FindYourSwitch } from "./home/FindYourSwitch";
import { Work } from "./home/Work";
import { Insights } from "./home/Insights";
import { Closing } from "./home/Closing";
import { Conversion, openFinder } from "../components/site/Conversion";

export default function Home() {
  const { openDiagnostic } = useSite();
  const [splash, setSplash] = useState(() => {
    try { return !sessionStorage.getItem("hasSeenSplash"); } catch (e) { return true; }
  });
  const [heroKey, setHeroKey] = useState(0);
  const finishSplash = () => {
    try { sessionStorage.setItem("hasSeenSplash", "1"); } catch (e) { /* storage unavailable (e.g. private mode) — non-fatal */ }
    setSplash(false);
    setHeroKey((k) => k + 1); // remount hero so it re-enters in the aligned "on" state
    if (typeof window !== "undefined") window.scrollTo({ top: 0, behavior: "auto" });
  };
  return (
    <div className="font-body bg-white">
      {splash && <Splash onEnter={finishSplash} />}
      <Hero key={heroKey} onReset={() => setSplash(true)} />
      <WhatWeDo />
      <Situations />
      <TrajectoryBand testId="home-band-1" label="From scattered effort to one trajectory" />
      <SwitchModel />
      <BelieveBlock testId="home-believe" />
      <TrajectoryBand src="/assets/editorial-system.jpg" testId="home-band-3" label="Strategy built as one system" />
      <Capabilities />
      <FindYourSwitch onOpenDiagnostic={openFinder} />
      <Work />
      <TrajectoryBand flip testId="home-band-2" label="Proof over promises" />
      <Insights />
      <Closing />
      <Conversion />
    </div>
  );
}

